(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.PersonaPathNutrition = api;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var entities = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&nbsp;': ' '
  };

  function decodeEntities(value) {
    return value
      .replace(/&(amp|lt|gt|quot|#39|nbsp);/gi, function (entity) {
        return entities[entity.toLowerCase()] || entity;
      })
      .replace(/&#(\d+);/g, function (_entity, code) {
        return String.fromCharCode(Number(code));
      });
  }

  function htmlToText(html) {
    return decodeEntities(
      String(html || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<[^>]+>/g, '')
    )
      .replace(/\r/g, '')
      .replace(/[ \t]+/g, ' ')
      .replace(/ *\n */g, '\n')
      .trim();
  }

  function servingLabelFromHtml(html) {
    var intro = String(html || '').split(/<ul\b/i)[0];
    var text = htmlToText(intro);
    var match = text.match(/\b(?:each|hver)?\s*(\d+|one|two|three|four|én|to|tre|fire)?\s*(softgels?|bløde kapsler|blød kapsel|capsules?|kapsel|kapsler|tablets?|tabletter)\b/i);
    var isDanish = /indeholder typisk|pr\. portion|kapsel|kapsler|tabletter/i.test(text);
    var numberWords = { one: '1', two: '2', three: '3', four: '4', 'én': '1', to: '2', tre: '3', fire: '4' };

    if (!match) {
      return isDanish ? 'Pr. portion' : 'Per serving';
    }

    var count = match[1] ? (numberWords[match[1].toLowerCase()] || match[1]) : '1';
    var unit = match[2].toLowerCase();
    var isSoftgel = /softgel|blød/.test(unit);
    var isCapsule = /kapsel|capsule/.test(unit) && !isSoftgel;
    if (isDanish) {
      var danishUnit = isSoftgel
        ? (count === '1' ? 'blød kapsel' : 'bløde kapsler')
        : isCapsule
          ? (count === '1' ? 'kapsel' : 'kapsler')
          : 'tabletter';
      return 'Pr. ' + count + ' ' + danishUnit;
    }

    var normalizedUnit = isSoftgel
      ? (count === '1' ? 'softgel' : 'softgels')
      : isCapsule
        ? (count === '1' ? 'capsule' : 'capsules')
        : (count === '1' ? 'tablet' : 'tablets');
    return 'Per ' + count + ' ' + normalizedUnit;
  }

  function normalizeNrv(value) {
    var match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*%/);
    return match ? match[1] + '%' : '—';
  }

  // "Zink- 15 mg" / "Vitamin B12- 1.000µg" / "D3-vitamin -25 µg": the amount is glued to the name by a
  // dash with a space on only one side. Returns [name, amount] or null. Names like "Omega-3" or
  // "B6-vitamin" (no space beside their dash) are left alone.
  function splitGluedAmount(text) {
    var match = text.match(/^(.*[^\s-])\s*[-–]\s+(\d.*)$/) || text.match(/^(.*[^\s-])\s+[-–](\d.*)$/);
    return match ? [match[1].trim(), match[2].trim()] : null;
  }

  function parseListItem(itemHtml) {
    var lines = htmlToText(itemHtml)
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    if (!lines.length) {
      return null;
    }

    var parts = lines[0]
      .split(/\s+-\s+|\s*,\s+/)
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);

    // "B6-vitamin- 2 mg - 143 %": a dash with a space only AFTER it glues the amount to the name
    // ("Omega-3" has no space after its dash, so it is left alone)
    var glued = parts.length && splitGluedAmount(parts[0]);
    if (glued) {
      parts = glued.concat(parts.slice(1));
    }

    if (parts.length < 2) {
      return null;
    }

    var nrvPart = parts.find(function (part) {
      return /%/.test(part);
    });
    var amountParts = parts.slice(1).filter(function (part) {
      return part !== nrvPart;
    });

    return {
      ingredient: parts[0].replace(/\s+-\s*$/, '').trim(),
      amount: amountParts.join(' - '),
      nrv: normalizeNrv(nrvPart),
      note: lines.slice(1).join(' ')
    };
  }

  function unwrapMetafieldHtml(html) {
    return String(html || '')
      .replace(/<p[^>]*>\s*(?:&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, '')
      .replace(/<p[^>]*>\s*((?:<div\b[\s\S]*?<\/div>)|(?:<ul\b[\s\S]*?<\/ul>))\s*<\/p>/gi, '$1');
  }

  // A theme-editor rich-text field written as <p>{{ metafield }}</p> renders as
  // <p></p><div class="metafield-...">...</div> (a <div> cannot sit inside a <p>),
  // so empty paragraphs can come before the label. Drop them first, or the label
  // is no longer "leading" and shows twice (once as the block title, once in the text).
  function dropLeadingEmptyParagraphs(html) {
    return String(html || '').replace(/^(?:\s|<p\b[^>]*>\s*(?:&nbsp;|\s|<br\s*\/?>)*<\/p>)+/i, '');
  }

  // The text starts with its own bold title on a line of its own ("Ingredienser:" + line break).
  // Returns { label: 'Ingredienser', html: <the text without that title> }, or null.
  // The label is in the language of the text, so it can replace a block title that is not
  // translated; the "line of its own" rule keeps inline text like "Contains: milk" untouched.
  function splitLeadingLabel(html) {
    var source = dropLeadingEmptyParagraphs(html);
    // a known title (Ingredients / Ingredienser / Disclaimer / Ansvarsfraskrivelse ...), with or without a line
    // break after it, even when it is a paragraph of its own
    var known = source.match(
      /^(\s*(?:<div\b[^>]*>\s*)?)<p\b([^>]*)>\s*<(?:strong|b)\b[^>]*>\s*(ingredients|ingredienser|allergens|allergener|allergy information|disclaimer|ansvarsfraskrivelse)\s*:?\s*(?:<br\s*\/?>\s*)*<\/(?:strong|b)>\s*(?:<br\s*\/?>\s*)*(<\/p>\s*)?/i
    );
    if (known) {
      var rest = source.slice(known[0].length);
      return { label: known[3].charAt(0).toUpperCase() + known[3].slice(1).toLowerCase(), html: known[1] + (known[4] ? '' : '<p' + known[2] + '>') + rest };
    }
    var match = source.match(
      /^(\s*(?:<div\b[^>]*>\s*)?<p\b[^>]*>\s*)<(?:strong|b)\b[^>]*>\s*([^<:]{1,48}?)\s*:?\s*(?:<br\s*\/?>\s*)*<\/(?:strong|b)>\s*(?:<br\s*\/?>\s*)+/i
    );
    if (!match) {
      return null;
    }
    return { label: decodeEntities(match[2]).trim(), html: source.replace(match[0], match[1]) };
  }

  function stripLeadingLabelHtml(html, label) {
    var source = String(html || '');
    var normalizedLabel = String(label || '').replace(/:\s*$/, '').trim();
    if (!normalizedLabel) {
      return source;
    }

    source = dropLeadingEmptyParagraphs(source);

    var escapedLabel = normalizedLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var leadingLabel = new RegExp(
      '^(\\s*(?:<div\\b[^>]*>\\s*)?<p\\b[^>]*>\\s*)' +
        '<(?:strong|b)\\b[^>]*>\\s*' +
        escapedLabel +
        '\\s*:?\\s*(?:<br\\s*\\/?>\\s*)*<\\/(?:strong|b)>\\s*' +
        '(?:<br\\s*\\/?>\\s*)*',
      'i'
    );

    return source.replace(leadingLabel, '$1');
  }

  // ---- Free-text rows (metafield written as lines of text, not as a bullet list) ----
  //
  // The English text puts one ingredient per line, "<b>Name</b> - 40mg". The Danish
  // translations often do not: some lost every line break (rows run together on one line),
  // some use "Name, 40 mg" and some "Name- 40 mg". So a bold run is treated as the start of
  // a row whatever separator follows, and bold runs are marked in the text with \u0001..\u0002
  // so the rows can be split apart again.
  var BOLD_OPEN = '\u0001';
  var BOLD_CLOSE = '\u0002';
  var INTRO_LINE = /typically provides|typisk|per portion|pr\. portion|nutrition reference value|næringsstofreferenceværdi/i;
  var FOOTNOTE_REF = /(?:nutrient|nutrition)\s+reference\s+value|(?:næringsstof|ernærings)referenceværdi/i;
  var FOOTNOTE_LINE = new RegExp('^\\*|' + FOOTNOTE_REF.source, 'i');
  // a footnote that shares a line with the last row: "Iodine - 150µg - (100% NRV*) *NRV=Nutrient Reference Value"
  var FOOTNOTE_TAIL = /\s\*\s*(?:NRV\s*)?=[\s\S]*$/i;

  // The footnote is the one line that explains the asterisk, not the whole paragraph it sits in.
  function footnoteFromText(text) {
    var found = '';
    String(text || '').split('\n').forEach(function (line) {
      var refAt = line.search(FOOTNOTE_REF);
      if (refAt < 0) return;
      var star = line.lastIndexOf('*', refAt);
      // cut the front off only when it is a data row ("Iodine - 150µg - (100% RI*) *NRV=..."), not "NRV*= ..."
      found = (star > 0 && /\d/.test(line.slice(0, star)) ? line.slice(star) : line).trim();
    });
    return found;
  }
  // "including:" / "inklusive:" introduces a list that belongs under the row above it
  // (the strains of a probiotic blend), as on a printed label.
  var LEAD_IN_START = /^(including|containing|comprising|inklusive|indeholdende|herunder)\s*:\s*([\s\S]*)$/i;
  var LEAD_IN_MID = /\s(including|containing|comprising|inklusive|indeholdende|herunder)\s*:\s*([\s\S]*)$/i;

  function stripMarks(text) {
    return String(text || '').replace(/[\u0001\u0002]/g, '');
  }

  function markedLines(html) {
    var marked = String(html || '')
      // Shopify writes "<br />" followed by a newline character; that newline is formatting, not a
      // second line break. Keep it, and every author line break becomes one blank-free line.
      .replace(/<br\s*\/?>[ \t]*\r?\n/gi, '<br>')
      .replace(/<(?:strong|b)\b[^>]*>/gi, BOLD_OPEN)
      .replace(/<\/(?:strong|b)>/gi, BOLD_CLOSE)
      .replace(/\u0002([ \t]*)\u0001/g, '$1');
    return htmlToText(marked)
      .split('\n')
      .reduce(function (lines, line) {
        return lines.concat(line.replace(/(\S)[ \t]*\u0001/g, '$1\n\u0001').split('\n'));
      }, []);
  }

  function splitSubItems(text) {
    var value = stripMarks(text).replace(/^[\s•*-]+/, '').trim();
    if (!value) return [];
    // A run of Latin names with the line breaks lost: "Bifidobacterium lactis Lactobacillus casei rhamnosus"
    var byGenus = value.split(/\s+(?=[A-Z])/);
    if (byGenus.length > 1 && byGenus.every(function (name) { return /^[A-Z][a-z-]+(?:\s+[a-z.-]+)+$/.test(name); })) {
      return byGenus;
    }
    return value.split(/\s*[;,]\s+/).map(function (item) { return item.trim(); }).filter(Boolean);
  }

  function rowFromParts(ingredient, parts) {
    var nrvPart = parts.find(function (part) { return /%/.test(part); });
    return {
      ingredient: ingredient,
      amount: parts.filter(function (part) { return part !== nrvPart; }).join(' - '),
      nrv: normalizeNrv(nrvPart),
      note: '',
      lead: '',
      subItems: []
    };
  }

  function splitAmountParts(text) {
    return text
      .split(/\s+[-–—]\s+|\s*,\s+/)
      .map(function (part) { return part.trim(); })
      .filter(Boolean);
  }

  // "Name - 40mg - 15%"  (the original rule: a dash with spaces around it)
  function parseDashRow(plain) {
    var parts = plain.split(/\s+-\s+/).map(function (part) { return part.trim(); }).filter(Boolean);
    if (parts.length < 2 || !/\d/.test(parts[1])) return null;
    var name = parts[0].replace(/:$/, '');
    var rest = parts.slice(1);
    // "Zink- 15 mg - 150 %": a dash with a space only AFTER it glues the amount to the name
    // ("Omega-3" has no space after its dash, so it is left alone)
    var glued = splitGluedAmount(name);
    if (glued) {
      name = glued[0];
      rest = [glued[1]].concat(rest);
    }
    return rowFromParts(name, rest);
  }

  // "<b>Name</b>, 40 mg"  /  "<b>Name</b>- 40 mg"  /  "<b>Name</b> 40 mg"
  function parseBoldRow(raw) {
    var match = raw.trim().match(/^\u0001([^\u0002]*)\u0002([\s\S]*)$/);
    if (!match) return null;
    var name = stripMarks(match[1]).replace(/:\s*$/, '').trim();
    var rest = stripMarks(match[2]).replace(/^[\s,;:–—-]+/, '').trim();
    if (!name || !/\d/.test(rest)) return null;
    return rowFromParts(name, splitAmountParts(rest));
  }

  // ", of which vitamin C, 125 mg"  (a sub-line that starts with a comma)
  function parseCommaRow(plain) {
    if (!/^[,;]/.test(plain)) return null;
    var parts = splitAmountParts(plain.replace(/^[\s,;]+/, ''));
    if (parts.length < 2 || !/\d/.test(parts[1])) return null;
    return rowFromParts(parts[0], parts.slice(1));
  }

  function parseTextRows(source) {
    var rows = [];
    var current = null;
    var collecting = false;

    markedLines(source).forEach(function (raw) {
      var plain = stripMarks(raw).trim();
      var startsBold = raw.trim().charAt(0) === BOLD_OPEN;

      if (!plain) {
        collecting = false;
        return;
      }

      if (FOOTNOTE_TAIL.test(raw)) {
        raw = raw.replace(FOOTNOTE_TAIL, '');
        plain = stripMarks(raw).trim();
        if (!plain) return;
      }

      var lead = plain.match(LEAD_IN_START);
      if (lead && current) {
        current.lead = lead[1].toLowerCase() + ':';
        current.subItems = current.subItems.concat(splitSubItems(lead[2]));
        collecting = true;
        return;
      }

      if (collecting && !startsBold && current && !FOOTNOTE_LINE.test(plain)) {
        current.subItems = current.subItems.concat(splitSubItems(plain));
        return;
      }
      collecting = false;

      if (INTRO_LINE.test(plain) || FOOTNOTE_LINE.test(plain)) return;

      // "Name - 10 Billion CFU including: A B C" -> the list after the colon is a sub-list
      var leadWord = '';
      var tail = null;
      var mid = raw.match(LEAD_IN_MID);
      if (mid) {
        leadWord = mid[1].toLowerCase() + ':';
        tail = mid[2];
        raw = raw.slice(0, mid.index);
        plain = stripMarks(raw).trim();
      }

      // "<b>C-vitamin</b>- 1000 mg - 1250 %": the dash rule would take "C-vitamin- 1000 mg" as the name,
      // so when a bold name starts the line and the dash rule's name contains "separator + digits",
      // the bold name wins.
      var dashRow = parseDashRow(plain);
      var boldRow = startsBold ? parseBoldRow(raw) : null;
      var row = dashRow;
      if (boldRow && (!dashRow || /[-–,]\s+\d/.test(dashRow.ingredient))) row = boldRow;
      row = row || parseCommaRow(plain);
      if (!row) return;

      if (tail !== null) {
        row.lead = leadWord;
        row.subItems = splitSubItems(tail);
        collecting = true;
      }
      rows.push(row);
      current = row;
    });

    return rows;
  }

  function parseNutritionHtml(html) {
    var source = unwrapMetafieldHtml(html);
    var rows = [];
    var itemPattern = /<li\b[^>]*>([\s\S]*?)<\/li>/gi;
    var match;

    while ((match = itemPattern.exec(source))) {
      var row = parseListItem(match[1]);
      if (row) {
        rows.push(row);
      }
    }

    if (!rows.length) {
      rows = parseTextRows(source);
    }

    if (!rows.length) {
      return null;
    }

    var footnote = '';
    var paragraphPattern = /<p\b[^>]*>([\s\S]*?)<\/p>/gi;
    while ((match = paragraphPattern.exec(source))) {
      footnote = footnoteFromText(htmlToText(match[1])) || footnote;
    }

    return {
      servingLabel: servingLabelFromHtml(source),
      language: detectLanguage(source),
      rows: rows,
      footnote: footnote
    };
  }

  function detectLanguage(html) {
    var text = htmlToText(html);
    return /næringsstofreferenceværdi|indeholder typisk|pr\. portion|kapsel|kapsler|dagligt/i.test(text)
      ? 'da'
      : 'en';
  }

  function appendCell(row, tagName, text, className, scope) {
    var cell = document.createElement(tagName);
    cell.className = className;
    cell.textContent = text;
    if (scope) {
      cell.setAttribute('scope', scope);
    }
    row.appendChild(cell);
    return cell;
  }

  function renderNutritionTable(source, target) {
    if (!source || !target) {
      return false;
    }

    var parsed = parseNutritionHtml(source.innerHTML);
    if (!parsed) {
      return false;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'pp-nutrition-table-wrap';
    var table = document.createElement('table');
    table.className = 'pp-nutrition-table';
    var labels = parsed.language === 'da'
      ? {
          ingredients: 'Aktive ingredienser',
          nrv: '%NRV*'
        }
      : {
          ingredients: 'Active ingredients',
          nrv: '%NRV*'
        };

    var head = document.createElement('thead');
    var headRow = document.createElement('tr');
    appendCell(headRow, 'th', labels.ingredients, 'pp-nutrition-table__ingredient', 'col');
    appendCell(headRow, 'th', parsed.servingLabel, 'pp-nutrition-table__amount', 'col');
    appendCell(headRow, 'th', labels.nrv, 'pp-nutrition-table__nrv', 'col');
    head.appendChild(headRow);
    table.appendChild(head);

    var body = document.createElement('tbody');
    parsed.rows.forEach(function (item) {
      var row = document.createElement('tr');
      var ingredientCell = appendCell(
        row,
        'th',
        item.ingredient,
        'pp-nutrition-table__ingredient',
        'row'
      );

      if (item.note) {
        var note = document.createElement('span');
        note.className = 'pp-nutrition-table__note';
        note.textContent = item.note;
        ingredientCell.appendChild(note);
      }

      // Strains of a probiotic blend, listed under the blend like a printed label
      if (item.lead || (item.subItems && item.subItems.length)) {
        var sub = document.createElement('span');
        sub.className = 'pp-nutrition-table__sub';

        if (item.lead) {
          var lead = document.createElement('span');
          lead.className = 'pp-nutrition-table__lead';
          lead.textContent = item.lead;
          sub.appendChild(lead);
        }

        if (item.subItems && item.subItems.length) {
          var list = document.createElement('ul');
          list.className = 'pp-nutrition-table__subitems';
          item.subItems.forEach(function (name) {
            var entry = document.createElement('li');
            entry.textContent = name;
            list.appendChild(entry);
          });
          sub.appendChild(list);
        }

        ingredientCell.appendChild(sub);
      }

      appendCell(row, 'td', item.amount, 'pp-nutrition-table__amount');
      appendCell(row, 'td', item.nrv, 'pp-nutrition-table__nrv');
      body.appendChild(row);
    });
    table.appendChild(body);
    wrapper.appendChild(table);

    if (parsed.footnote) {
      var footnote = document.createElement('p');
      footnote.className = 'pp-nutrition-table__footnote';
      footnote.textContent = parsed.footnote;
      wrapper.appendChild(footnote);
    }

    target.replaceChildren(wrapper);
    target.hidden = false;
    source.hidden = true;
    return true;
  }

  return {
    parseNutritionHtml: parseNutritionHtml,
    renderNutritionTable: renderNutritionTable,
    splitLeadingLabel: splitLeadingLabel,
    stripLeadingLabelHtml: stripLeadingLabelHtml
  };
});
